import React from "react";
import {Button} from "@mui/material";
import {NavLink} from "react-router-dom";

interface NavButtonProps {
    name: string;
    to: string;
}

const NavButton: React.FC<NavButtonProps> = ({name, to}) => {
    return <Button
        component={NavLink}
        to={to}
        color="inherit"
        sx={{
            '&.active': {
                fontWeight: 'bold',
            },
            color: "white"
        }}
    >
        {name}
    </Button>;
}

export default NavButton;